import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Modal, Form} from 'semantic-ui-react';

import ProductStockData from "../../data/ProductStockData";
import {openModalProductStockUpdate} from "../../actions/ModalProductStockUpdateActions";
import {updateProductStock} from "../../actions/ProductStockActions";
import {showToast} from "../../actions/ToastAction";
import {selectProduct} from "../../actions/ProductSelectActions";
import update from "react-addons-update";

class ProductStockUpdate extends Component {

    constructor() {
        super();

        this.state = {
            quantity: 0,
            observations: '',
            quantity_error: false,
            sending: false,
            product:{}
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.product_select) {
            this.setState({product: nextProps.product_select});
        }
    }

    handleClose = () => {
        this.props.openModalProductStockUpdate({
            is_open: false,
            is_add: true,
            product: null,
            stock: null
        });
        this.setState({quantity:0, sending:false, quantity_error:false, observations: ''});
    };

     handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.quantity <= 0 || (this.state.quantity > this.props.modal.stock.total && !this.props.modal.is_add)) {
            this.setState({quantity_error: true})
        } else {
            this.setState({sending: true});
            let data = {
                product: this.props.modal.product.id,
                branch_office: this.props.modal.stock.id,
                quantity: this.props.modal.is_add ? this.state.quantity:(-1*this.state.quantity),
                track_type: this.props.modal.is_add ? 3:5,
                observations:  this.props.modal.is_add ? '':this.state.observations
            };
            ProductStockData.update(data, (res) => {
                this.setState({sending: false});
                if (res.update) {
                    let stock = this.props.modal.stock;
                    stock.total += data.quantity;
                    let product = update(this.state.product, {
                            count_stock: {
                                $set: this.state.product.count_stock + data.quantity
                            }
                    });
                    this.props.selectProduct(null);
                    this.props.selectProduct(product);
                    this.props.updateProductStock(stock);
                    this.props.showToast({type:'success', message:res.message});
                    this.handleClose();
                } else {
                    this.props.showToast({type:'error', message:res.message});
                }
            }).catch(()=>{
                this.props.showToast({type:'error', message:'No hay conexión a internet!'});
            });
        }
    };

    handleTotalChange = (event) => {
        if (event.target.value.trim() !== '') {
            let quantity = parseInt(event.target.value, 0);
            if (quantity >= 0) {
                this.setState({quantity});
                this.setState({quantity_error: false})
            } else {
                this.setState({quantity_error: true})
            }
        } else {
            this.setState({quantity_error: true, quantity: ''})
        }
    };

    handleObservationsChange = (event) => {
        this.setState({observations: event.target.value});
    };

    render() {
        return (
            <Modal size='tiny' dimmer='inverted' open={this.props.modal.is_open} onClose={this.handleClose}>
                <Modal.Header>
                    {`${this.props.modal.product ? this.props.modal.product.name:''} (${this.props.modal.stock ? this.props.modal.stock.total:0} disponibles) - ${this.props.modal.is_add? 'Actualizar Inventario':'Dar de Baja'}`}
                </Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <Form onSubmit={this.handleSubmit}>
                            <Form.Input label={`Unidades a ${this.props.modal.is_add ? 'Agregar':'Dar de Baja'}:`} min={0} type='number' value={this.state.quantity}
                                        onChange={this.handleTotalChange} error={this.state.quantity_error}/>
                            {!this.props.modal.is_add ? <Form.TextArea label='Observaciones' placeholder='Observaciones'
                                           value={this.state.observations}
                                           onChange={this.handleObservationsChange}/>:null}
                        </Form>
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.handleClose} icon='x' labelPosition='left' content="Cancelar"/>
                    <Button primary loading={this.state.sending} disabled={this.state.sending} icon='check'
                            labelPosition='left' content={`${this.props.modal.is_add ? 'Actualizar':'Dar de Baja'}`} onClick={this.handleSubmit}/>
                </Modal.Actions>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        modal: state.get('product_stock_update_modal'),
        product_select: state.get('product_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalProductStockUpdate(modal){
            dispatch(openModalProductStockUpdate(modal))
        },
        showToast(alert){
            dispatch(showToast(alert))
        },
        updateProductStock(product_stock){
            dispatch(updateProductStock(product_stock))
        },
        selectProduct(data){
            dispatch(selectProduct(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductStockUpdate);



// WEBPACK FOOTER //
// ./src/components/inventories/ProductStockUpdate.js